// extracted by mini-css-extract-plugin
module.exports = {"circular-button":"QRCodeButton_circular-button__k8it5"};